const { render, useEffect, useState } = wp.element;
const { addQueryArgs } = wp.url;
const { apiFetch } = wp;

import Map from './components/map';

const App = ( { attributes, productId } ) => {
	const showLogos = attributes?.showLogos;
	const displayMode = attributes?.displayMode; // compact or large
	const perPage = +attributes?.perPage;
	const hideAddressField = attributes?.hideAddressField;
	const hidePhoneField = attributes?.hidePhoneField;
	const hideWebsiteField = attributes?.hideWebsiteField;
	const hideRetailersWithoutLocation = attributes?.hideRetailersWithoutLocation;

	const [ retailers, setRetailers ] = useState( [] );
	const [ isRetailersLoaded, setIsRetailersLoaded ] = useState( false );

	const queryParams = {
		per_page: Number.MAX_SAFE_INTEGER,
	};

	if ( productId ) {
		queryParams.product_id = productId;
	}

	useEffect( () => {
		async function loadRetailers() {
			try {
				const retailersCollection = await apiFetch( {
					path: addQueryArgs( '/qala-b2b-wholesale/v1/retailers', queryParams ),
				} );

				if ( retailersCollection.data[ 0 ] ) {
					const parsedRetailers = parseRetailers( retailersCollection.data[ 0 ] );
					setRetailers( parsedRetailers );
				}
			} catch ( e ) {
				setRetailers( [] );
			}

			setIsRetailersLoaded( true );
		}
		loadRetailers();
	}, [] );

	if ( ! isRetailersLoaded ) {
		return 'Loading retailers...';
	}

	return (
		<Map retailers={ retailers } showLogos={ showLogos } displayMode={ displayMode } perPage={ perPage } hideAddressField={ hideAddressField } hidePhoneField={ hidePhoneField } hideWebsiteField={ hideWebsiteField } hideRetailersWithoutLocation={ hideRetailersWithoutLocation } />
	);
};

const parseRetailers = retailers => {
	if ( retailers.length === 0 ) {
		return [];
	}

	const response = retailers.map( retailer => {
		const { id, acf, title, link, logo, phone, website } = retailer;

		const {
			google_map: googleMap,
		} = acf;

		const { address, lat, lng } = googleMap;

		return {
			id,
			address,
			lat,
			lng,
			content: {
				title,
				website,
				phone,
				link,
				logo,
			},
		};
	} );

	return response;
};

document.addEventListener( 'DOMContentLoaded', function() {
	document
		.querySelectorAll( '.wp-block-qala-b2b-wholesale-retailers-gmap' )
		.forEach( element => {
			render( <App attributes={ JSON.parse( element.dataset.attributes ) } productId={ element.dataset.productid } />, element );
		} );
} );

export default App;
